/** Navigation module Documents & Preuves — BT-022 */

export const DOCUMENTS_PREUVES_MODULE_FR = "Documents & Preuves";
export const DOCUMENTS_PREUVES_MODULE_EN = "Documents & Evidence";

export const ADMIN_DOCUMENTS_PREUVES_BASE = "/admin/documents-preuves";
export const SHOTOKAN_DOCUMENTS_PREUVES_BASE = "/admin/shotokan-black-dragon/documents-preuves";

/** Anciennes routes BT-019 — redirigées vers le module central */
export const LEGACY_DOCUMENTS_PREUVES_ADMIN_PATHS = [
  "/admin/documents-autorite",
  "/admin/dossiers-preuves",
  "/admin/journal-validation",
];

export const DOCUMENTS_PREUVES_SUB_NAV = [
  { segment: "", labelFr: "Vue d'ensemble", labelEn: "Overview", testId: "dp-nav-overview" },
  { segment: "documents", labelFr: "Documents", labelEn: "Documents", testId: "dp-nav-documents" },
  { segment: "dossiers", labelFr: "Dossiers de preuves", labelEn: "Evidence dossiers", testId: "dp-nav-dossiers" },
  { segment: "validation", labelFr: "Validation", labelEn: "Validation", testId: "dp-nav-validation" },
  { segment: "journal", labelFr: "Journal", labelEn: "Log", testId: "dp-nav-journal" },
  { segment: "import", labelFr: "Import contrôlé", labelEn: "Controlled import", testId: "dp-nav-import" },
  { segment: "securite", labelFr: "Sécurité future", labelEn: "Future security", testId: "dp-nav-securite" },
];

export const SHOTOKAN_DOCUMENTS_BASE = "/admin/shotokan-black-dragon";

/** Base path Documents & Preuves selon le contexte (standalone legacy ou intégré Shotokan). */
export function resolveDocumentsPreuvesBase(pathname) {
  if (pathname.startsWith(SHOTOKAN_DOCUMENTS_PREUVES_BASE)) return SHOTOKAN_DOCUMENTS_PREUVES_BASE;
  return ADMIN_DOCUMENTS_PREUVES_BASE;
}
